// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { focusedItemText, itemText, linkStyles } from "@conklin/App/SharedStyles/AutoCompleteSharedStyles";
import { autocompleteBrandsStyles } from "@conklin/Overrides/Widgets/Header/AutocompleteBrands";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { mergeWithCss } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

autocompleteBrandsStyles.headerText = {
    weight: fontConfig.weight.bold,
    lineHeight: "16px",
    css: css`
        text-align: left;
        margin: 4px 0 8px 0;
    `,
};

autocompleteBrandsStyles.brandItemText = itemText;
autocompleteBrandsStyles.focusedBrandItemText = focusedItemText;
autocompleteBrandsStyles.link = {
    ...mergeWithCss(linkStyles, {
        css: css`
            ${TypographyStyle} {
                color: ${getColor("text.main")};

                &:hover {
                    color: ${getColor("common.ui10")};
                }
            }
        `,
    }),
};

autocompleteBrandsStyles.focusedLink = {
    ...mergeWithCss(linkStyles, {
        css: css`
            ${TypographyStyle} {
                color: ${getColor("text.main")};

                &:hover {
                    color: ${getColor("common.ui10")};
                }
            }
        `,
    }),
};
